import { Modal, ModalOverlay, useBreakpointValue } from '@chakra-ui/react';
import { FC, useState } from 'react';

import { ForgotPassword } from '@/components/ui/shared/modals/LoginPopup/components/ForgotPassword';
import { LoginModal } from '@/components/ui/shared/modals/LoginPopup/components/LoginModal';

interface ILibrariansContactFormProps {
  isOpen: boolean;
  onClose: () => void;
}

export const LogInPopup: FC<ILibrariansContactFormProps> = ({ isOpen, onClose }) => {
  const isCentered = useBreakpointValue({ base: false, md: true });
  const [isForgotPassword, setIsForgotPassword] = useState(false);

  function handleOnClose() {
    setIsForgotPassword(false);
    onClose();
  }

  return (
    <Modal isOpen={isOpen} onClose={handleOnClose} size="xl" isCentered={isCentered}>
      <ModalOverlay />
      {!isForgotPassword && <LoginModal onClose={handleOnClose} setIsForgotOpen={setIsForgotPassword} />}
      {isForgotPassword && <ForgotPassword onClose={handleOnClose} />}
    </Modal>
  );
};
